import { Router, NavigationEnd } from '@angular/router';
import { ChangeDetectorRef, Input, OnInit, OnDestroy, Component } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { CartService } from './../cart/cart.service';
import { CaseIdentifier, CaseType } from './../shared/case-identifier';
import { CourtCase } from './court-case';
import { EventService } from './event.service';
import { HtmlUtil } from './../shared/html-util';
import { FileNumberUtil } from './../shared/file-number-util';

@Component({
    template: ''
  })
  export class BaseSearchResultsTableComponent implements OnDestroy, OnInit {

  @Input() cases: CourtCase[];
  @Input() errors: string[];
  @Input() requestIsInFlight: boolean;
  lastViewedCase: CaseIdentifier;
  subscriptions: Subscription[] = [];

  private previousURLincludedDetailsView = false;

  constructor(private cartService: CartService,
              protected cd: ChangeDetectorRef,
              private eventService: EventService,
              private router: Router
            ) {
    // Everything in this component is static except the cart-related info (if a case is in the cart or not)
    // Get change detector to do its thing when the cart changes
    this.subscriptions.push(
        cartService.cartSizeChanged$.subscribe(size => cd.markForCheck())
    );

    this.subscriptions.push(
        router.events.subscribe(theRoute => {
            if (theRoute instanceof NavigationEnd) {

                // When navigating from details view back to list, request focus on the last viewed case
                const currentURLincludedDetailsView = this.doesURLIncludeCaseDetailsView(router.url);
                if (this.previousURLincludedDetailsView && !currentURLincludedDetailsView) {
                    setTimeout(() => {
                        this.requestFocusForLastViewedCase();
                    }, 0);
                }
                this.previousURLincludedDetailsView = router.url.indexOf('view:details') > -1;

                const url = theRoute.urlAfterRedirects;
                if (url.indexOf('view:details/') !== -1) {
                    const outlet = url.substring(url.indexOf('view:details/'), url.indexOf(')'));
                    const parts: string[] = outlet.split('/');
                    this.lastViewedCase = new CaseIdentifier(parts[1] as CaseType, parts[2], parts[3]);
                }
            }
        })
    );
   }

   protected requestFocusForLastViewedCase() {}

   private doesURLIncludeCaseDetailsView(url: string) {
    return url.indexOf('view:details') > -1;
   }

    ngOnInit() {
        this.subscriptions.push(
            this.eventService.otherDataLoaded$.subscribe(() => this.cd.markForCheck())
        );
    }

    ngOnDestroy() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    onViewCaseSelected(caseIdentifier: CaseIdentifier): void {
        this.router.navigate(
            [{outlets: {
                // tslint:disable-next-line:max-line-length
                view: ['details', caseIdentifier.type, caseIdentifier.county, FileNumberUtil.normalizeCaseNumberWithoutCentury(caseIdentifier.caseNumber)]
            }}]);
    }

    isCaseLastViewed(caseIdentifier: CaseIdentifier): boolean {
        if (caseIdentifier == null || caseIdentifier === undefined) {
            return false;
        }
        return caseIdentifier.equals(this.lastViewedCase);
    }

    isCaseInCart(caseIdentifier: CaseIdentifier): boolean {
        return this.cartService.contains(caseIdentifier);
    }
    addCaseToCart(aCase: CourtCase): void {
        this.cartService.addCase(aCase);
    }
    removeCaseFromCart(aCase: CourtCase): void {
        this.cartService.removeCase(aCase);
    }

   /**
    * To resolve popover flicking issue upon mouse over/leave, hide or not the window scrollbar
    * @param type string
   */
   public popOverHandler(type: string) {
     HtmlUtil.popOverHandler(type);
   }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/base-search-results-table.component.ts